import { render, staticRenderFns } from "./TransactionChart.vue?vue&type=template&id=640c7ed7&"
import script from "./TransactionChart.vue?vue&type=script&lang=js&"
export * from "./TransactionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports